/**
 * System entities are used to identify gently-owned entities in the system,
 * especially in the case of polymorphic relationships.
 */
export enum SystemEntity {
  // CORE
  CORE_MEMORY_BANK_NOTE = "CORE_MEMORY_BANK_NOTE",
  CORE_MEMORY_BANK_NOTE_USAGE = "CORE_MEMORY_BANK_NOTE_USAGE",
  ORGANIZATION = "ORGANIZATION",
  CORE_DOCUMENT = "CORE_DOCUMENT",
  CORE_DOCUMENT_OCR_RESULT = "CORE_DOCUMENT_OCR_RESULT",

  // AR
  AR_CUSTOMER = "AR_CUSTOMER",
  AR_STAGED_SALES_ORDER = "AR_STAGED_SALES_ORDER",
  AR_SALES_ORDER = "AR_SALES_ORDER",
  AR_SALES_ORDER_LINE_ITEM = "AR_SALES_ORDER_LINE_ITEM",

  // AP
  AP_INVOICE = "AP_INVOICE",
  AP_INVOICE_LINE_ITEM = "AP_INVOICE_LINE_ITEM",
  AP_SUPPLIER = "AP_SUPPLIER",
  INTERNAL_PURCHASE_ORDER = "INTERNAL_PURCHASE_ORDER",
  INTERNAL_PURCHASE_ORDER_LINE_ITEM = "INTERNAL_PURCHASE_ORDER_LINE_ITEM",

  // FINANCE
  PAYMENT = "PAYMENT",
  FINANCIAL_TRANSACTION = "FINANCIAL_TRANSACTION",
  CHARGE = "CHARGE",

  // INBOUND EMAILS
  INBOUND_EMAIL = "INBOUND_EMAIL",
  OUTBOUND_EMAIL = "OUTBOUND_EMAIL",

  // SUPPLY CHAIN MANAGEMENT
  SCM_SHIPMENT = "SCM_SHIPMENT",
  SHIPPING_DOCUMENT = "SHIPPING_DOCUMENT",
  SHIPPING_DOCUMENT_LINE_ITEM = "SHIPPING_DOCUMENT_LINE_ITEM",

  // WORKFLOWS
  WORKFLOW_DEFINITION = "WORKFLOW_DEFINITION",
  WORKFLOW_RUN = "WORKFLOW_RUN",
  STEP_RUN = "STEP_RUN",
}
